"use client";

import { AuthBootstrapper } from "@/components/auth/auth-bootstrapper";
import dynamic from "next/dynamic";

const CompareBar = dynamic(
  () => import("@/components/product/compare-bar").then((m) => m.CompareBar),
  { ssr: false }
);
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";
import { useState } from "react";

export function Providers({ children }: { children: React.ReactNode }) {
  const [client] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: { staleTime: 60_000, retry: 1 },
        },
      })
  );

  return (
    <QueryClientProvider client={client}>
      <AuthBootstrapper />
      {children}
      <Toaster position="top-center" richColors />
      <CompareBar />
    </QueryClientProvider>
  );
}
